import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useEffect, useState } from "react";
import { GraphQLError } from "graphql";

export const FRAGMENT_WORK_PROGRESS = new FragmentDefiner(
	"Property",
	`
    id
    project {
		images {
            image
            tag
        }
    }
`
);

interface useWorkProgressResponse {
	images: Image[];
}

export const useWorkProgress = (data: Image[]): useWorkProgressResponse => {
	const [images, setImages] = useState<Image[]>([]);

	useEffect(() => {
		const workProgressImages = data?.filter(image => image?.tag == "construction_advances");
		setImages(workProgressImages);
	}, [data]);

	return {
		images,
	};
};
